module.exports = __webpack_public_path__ + "img/1493326295.b0254e04.jpg";